export default "__VITE_ASSET__951ngetd__"